<template>
  <div>
    <HomeHeaderNavBar></HomeHeaderNavBar>
    <DownloadHeader></DownloadHeader>
    <DownloadPage
      :urlStringType0="urlType0"
      :urlStringType2="urlType2"
      :urlStringType3="urlType3"
      :urlStringType4="urlType4"
    ></DownloadPage>
    <HomeFooter></HomeFooter>
  </div>
</template>

<script>
import HomeHeaderNavBar from "../home/components/HeaderNavBar";
import DownloadHeader from "@/pages/download/components/DownloadHeader";
import DownloadPage from "@/pages/download/components/DownloadPage";

import HomeFooter from "../home/components/Footer";
import Fixed from "@/pages/fixed";

import { downloadList } from "../../api";

export default {
  name: "Download",
  components: {
    HomeHeaderNavBar,
    DownloadHeader,
    DownloadPage,
    HomeFooter,
    Fixed
  },

  data() {
    return {
      urlType0: "", // Android  手机
      urlType2: "", // Android  TV
      urlType3: "", // Android  工位
      urlType4: "" // Android  会议
    };
  },
  mounted() {
    downloadList({}).then(res => {
      if (res.data.code == 200) {
        let data = res.data.data;
        for (var item of data) {
          switch (item.appType) {
            case 0:
              this.urlType0 = item.downloadLink;
              break;
            case 2:
              this.urlType2 = item.downloadLink;
              break;
            case 3:
              this.urlType3 = item.downloadLink;
              break;
            case 4:
              this.urlType4 = item.downloadLink;
              break;

            default:
              break;
          }
        }
      }
    });
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.downloadBtn {
  padding: 3em 0em;
  text-align: center;

  div {
    width: 200px;
    border: 2px solid #dcdfe6;
    display: inline-block;
    text-align: center;
    border-radius: 30px;
    margin: 25px;
    padding: 10px;

    img {
      font-size: 30px;
      cursor: pointer;
    }

    p {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/download/Download.vue